import { ValidatingInput, InputComponentProps } from '~/components/validating-input';

interface SecondaryIdentifierProps extends InputComponentProps {
  hideRequirements?: boolean;
  fieldMetadata?: SecondaryIdFieldMetadata;
}

export interface SecondaryIdFieldMetadata {
  name: string;
  label: string;
  helpText: string;
  validations: Array<string>;
  optional?: boolean;
}

export const SecondaryIdentifier = ({
  hideRequirements,
  fieldMetadata,
  ...props
}: SecondaryIdentifierProps) => {
  if (!fieldMetadata) {
    return null;
  }

  const { helpText, label, validations } = fieldMetadata;
  const requirements = helpText;
  const validate = ({ value }) => {
    if (!value) return false;
    if (!validations.length) return true;
    const isValid = !!validations.find(pattern => new RegExp(pattern!).test(value));
    if (!isValid) {
      return `Please enter a valid ${label}`;
    }
    return isValid;
  };

  return (
    <ValidatingInput
      debounceValidation={0}
      label={label}
      name="secondaryIdentifier"
      requirements={hideRequirements ? '' : requirements}
      validate={validate}
      helpContent={{
        type: 'ENROLLMENT_FIELDS',
      }}
      {...props}
    />
  );
};
